// Inline text: plain words, with **bold** for the exact words on a Scout button
// or label. Everything else is escaped; no other markup exists.

const ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (c) => ESCAPES[c]);
}

export interface Span {
  text: string;
  bold: boolean;
}

/** The text's spans, or an error when a ** is left open or a label is empty. */
export function parseInline(text: string): { spans: Span[]; error: string | null } {
  const parts = text.split('**');
  if (parts.length % 2 === 0) return { spans: [{ text, bold: false }], error: `An unclosed ** in "${text}"` };
  const spans: Span[] = [];
  for (let i = 0; i < parts.length; i++) {
    const bold = i % 2 === 1;
    if (bold && parts[i].trim() === '') return { spans: [{ text, bold: false }], error: `An empty **** in "${text}"` };
    if (parts[i]) spans.push({ text: parts[i], bold });
  }
  return { spans, error: null };
}

export function renderInline(text: string): string {
  return parseInline(text).spans
    .map((s) => (s.bold ? `<strong class="hx-label">${escapeHtml(s.text)}</strong>` : escapeHtml(s.text)))
    .join('');
}

export function boldLabels(text: string): string[] {
  return parseInline(text).spans.filter((s) => s.bold).map((s) => s.text);
}
